import { render } from "./VenueOrderActions.vue?vue&type=template&id=2588a349&scoped=true"
import script from "./VenueOrderActions.vue?vue&type=script&lang=js"
export * from "./VenueOrderActions.vue?vue&type=script&lang=js"

import "./VenueOrderActions.vue?vue&type=style&index=0&id=2588a349&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2588a349"]])

export default __exports__